const SummaryStepStyles = () => ({
  checkbox: {
    marginLeft: '-7px',
    display: 'flex',
    alignItems: 'center'
  },
  tableWrapper: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: '#ebebeb',
      borderRadius: '10px',
      margin: '2px'
    },
    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: '#9E9E9E',
      borderRadius: '10px'
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#7b7a7a'
    }
  },
  leftWrapper: {
    flexGrow: 1
  },
  dialogActions: {
    background: 'transparent',
    padding: '8px 0px'
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '5px'
  },
  actionBarContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  proofSelect: {
    minWidth: '150px'
  },
  blueItem: {
    color: '#2962FF'
  },
  progressText: {
    fontSize: '0.875rem',
    marginRight: '7px'
  },
  progressIcon: {
    marginRight: '4px'
  },
  doneText: {
    fontSize: '12px',
    color: '#2E7D32',
    marginRight: '7px'
  },
  doneIcon: {
    fontSize: '14px',
    color: '#2E7D32',
    marginRight: '4px'
  },
  errorText: {
    fontSize: '12px',
    color: '#f44336',
    marginRight: '7px'
  },
  errorIcon: {
    color: '#f44336',
    fontSize: '14px',
    marginRight: '4px'
  },
  indicatorsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '17px',
    marginBottom: '8px'
  },
  batchIndicators: {
    fontSize: 15,
    fontWeight: 400
  },
  helper: {
    width: '100%'
  },
  button: {
    border: '1px solid #E0E0E0',
    minWidth: '160px',
    background: '#ffffff',
    '& span': {
      padding: 0
    }
  },
  disableButton: {
    background: '#F5F5F5',
    border: '1px solid #EEEEEE !important',
    minWidth: '160px',
    '& span': {
      padding: 0
    }
  },
  loading: {
    width: '100%',
    height: '100%',
    alignSelf: 'center'
  },
  tag: {
    color: '#212121',
    'font-size': '12px',
    'line-height': '12px',
    textDecoration: 'none',
    'box-sizing': 'border-box',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    'border-radius': '2px',
    padding: '0 5px'
  }
});

export default SummaryStepStyles;
